import React, { useState } from 'react';

export const DropZone = ({ containerId, colIdx, index, onReorder }) => {
  const [active, setActive] = useState(false);
  
  const handleDragOver = (e) => {
    if (!e.dataTransfer.types.includes('reorderid')) return;
    e.preventDefault();
    e.stopPropagation();
    setActive(true);
  };
  
  const handleDragLeave = () => setActive(false);
  
  const handleDrop = (e) => {
    const reorderId = e.dataTransfer.getData('reorderId');
    if (!reorderId) { setActive(false); return; }
    e.preventDefault();
    e.stopPropagation();
    setActive(false);
    onReorder(reorderId, containerId, colIdx, index);
  };
  
  return (
    <div 
      onDragOver={handleDragOver} 
      onDragLeave={handleDragLeave} 
      onDrop={handleDrop}
      className={`w-full transition-all duration-150 ${active ? 'h-10 bg-teal-50 border-2 border-dashed border-teal-400 rounded-lg my-1' : 'h-2 opacity-0 hover:opacity-100 hover:h-6 hover:border hover:border-dashed hover:border-teal-300 hover:rounded-md'}`} 
    />
  );
};